<kal-card (dismissed)="closeFilters()"
          [dismissable]="true">

    <kal-card-title>
        Filtrer
    </kal-card-title>

    <kal-card-content [formGroup]="form">

        <div class="gup-C-filterCard">

            <section>

                <!-- Catégories -->
                <article>

                    <kal-form-field class="gup-C-formFieldSize--select" *ngIf="!disabledFilters?.categoryCode">

                        <kal-select id="document_bank_dialog_filters_category"
                                    label="Catégorie"
                                    formControlName="categoryCode">

                            <kal-option [value]="null">
                                Tous
                            </kal-option>

                            <kal-option *ngFor="let category of categoriesList"
                                        [value]="category.Code">
                                {{ category.Libelle }}
                            </kal-option>

                        </kal-select>

                    </kal-form-field>

                    <!-- Types -->

                    <kal-form-field class="gup-C-formFieldSize--select" *ngIf="!disabledFilters?.type">

                        <kal-select id="document_bank_dialog_filters_type"
                                    label="Type"
                                    formControlName="type">

                            <kal-option [value]="null">
                                Tous
                            </kal-option>

                            <kal-option *ngFor="let type of typesList"
                                        [value]="type">
                                {{ type }}
                            </kal-option>

                        </kal-select>

                    </kal-form-field>

                    <!-- Statuts -->

                    <kal-form-field class="gup-C-formFieldSize--select" *ngIf="!disabledFilters?.statusId">

                        <kal-select id="document_bank_dialog_filters_status"
                                    label="Statut"
                                    formControlName="statusId">

                            <kal-option [value]="null">
                                Tous
                            </kal-option>

                            <kal-option *ngFor="let status of statusList"
                                        [value]="status.Id">
                                {{ status.Libelle }}
                            </kal-option>

                        </kal-select>

                    </kal-form-field>

                    <!-- Date dépassée -->

                    <kal-checkbox formControlName="hasExpired"
                                  id="document_bank_dialog_filters_has_expired"
                                  kalTheme="switch"
                                  label="Date dépassée"
                                  *ngIf="!disabledFilters?.hasExpired">
                    </kal-checkbox>

                    <!-- non lié à un article -->

                    <kal-checkbox formControlName="isUnlinked"
                                  id="document_bank_dialog_filters_is_unlinked"
                                  kalTheme="switch"
                                  label="Non lié à un article"
                                  *ngIf="!disabledFilters?.isUnlinked">
                    </kal-checkbox>

                </article>

            </section>

        </div>

    </kal-card-content>

    <kal-card-actions>

        <kal-button id="image_bank_dialog_filters_apply"
                    kalTheme="primary"
                    (click)="applyFilters()">
            Appliquer
        </kal-button>

        <kal-button id="image_bank_dialog_filters_cancel"
                    kalTheme="secondary"
                    (click)="closeFilters()">
            Annuler
        </kal-button>

    </kal-card-actions>

</kal-card>
